import { render, staticRenderFns } from "./station_saddle_plc.vue?vue&type=template&id=cd5de90c&scoped=true"
import script from "./station_saddle_plc.vue?vue&type=script&lang=js"
export * from "./station_saddle_plc.vue?vue&type=script&lang=js"
import style0 from "./station_saddle_plc.vue?vue&type=style&index=0&id=cd5de90c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5de90c",
  null
  
)

export default component.exports